import { connect } from "react-redux";
import Grid from "../../../../components/Grid";
import { EditSubCategoryButton } from "./EditSubCategoryButton";
import { HandleActivationSubCategory } from "./HandleActivationSubCategory";
import { useEffect, useState } from "react";

const ActionsSubCategories = (props) => {
  return (
    <>
      <EditSubCategoryButton {...props} />
      <HandleActivationSubCategory {...props} />
    </>
  );
};

const COLUMNS = [
  {
    title: "ID de Subcategoría",
    render: (rowData) => {
      return <span>{rowData?.id || null}</span>;
    },
    field: "id",
    searchable: true,
  },
  {
    title: "Código subcategoría",
    render: (rowData) => {
      return <span>{rowData?.subCategoryCode || ''}</span>;
    },
    field: "subCategoryCode",
    searchable: true,
  },
  {
    title: "Nombre de Subcategoría",
    render: (rowData) => {
      return <span>{rowData?.subCategoryName || ''}</span>;
    },
    field: "subCategoryName",
    searchable: true,
  },
  {
    title: "Categoría asociada",
    render: (rowData) => {
      return <span>{rowData?.category?.name || ''}</span>;
    },
    field: "category.name",
    searchable: true,
  },
  {
    title: "Acciones",
    render: (rowData) => {
      return (
        <ActionsSubCategories
          isActive={rowData.isActive}
          idSubCategory={rowData.id}
        />
      );
    },
  },
];

const ContentSubCategoriesComponent = ({
  subCategories = [],
  reduxGetSubCategories = () => {},
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [offset, setOffset] = useState(10);
  const [search, setSearch] = useState("");

  const itemsSubcategories = Array.isArray(subCategories?.items)
    ? subCategories.items
    : [];

  const handleOnChangeRange = (value) => {
    setOffset(value);
    reduxGetSubCategories({
      page: 1,
      offset: value,
      search: search,
    });
  };

  const handleOnChangeSearch = (value) => {
    setSearch(value);
    reduxGetSubCategories({
      page: 1,
      offset: offset,
      search: value,
    });
  };

  useEffect(() => {
    reduxGetSubCategories({
      page: currentPage,
      offset: offset,
      search: search,
    });
  }, [currentPage, offset, search, reduxGetSubCategories]);

  return (
    <div className="card shadow mb-4">
      <div className="card-header py-3">
        <h6 className="m-0 font-weight-bold text-primary">
          Listado de Subcategorías
        </h6>
      </div>
      <div className="card-body">
        <Grid
          cols={COLUMNS}
          data={itemsSubcategories}
          page={subCategories?.page || currentPage}
          pages={subCategories?.totalPages || 0}
          total={subCategories?.total || 0}
          offset={offset}
          onChangePage={(page) => setCurrentPage(page)}
          onChangeRange={handleOnChangeRange}
          defaultValue={search}
          onChangeSearch={handleOnChangeSearch}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    subCategories: state.subCategoriesState.subCategories,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reduxGetSubCategories: (payload) =>
      dispatch({
        type: "FETCH_SUB_CATEGORIES_REQUEST",
        value: payload,
      }),
  };
};

export const ContentSubCategories = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContentSubCategoriesComponent);
